// The Market's Send-resources target coordinates, remembered per world (on this device) — like the Rally Point's
// (state/rallyTarget), so they're still there after sending, after switching to another city, and after reopening the
// app (Ben, Oct 14 2026). Kept apart from the rally target: one is usually a friend, the other an enemy.
import { create } from "zustand";

const KEY = "valor-web:market-target";
type Target = { x: string; y: string };

function load(): Record<string, Target> {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}") as Record<string, Target>;
  } catch {
    return {};
  }
}

interface MarketTargetState {
  byWorld: Record<string, Target>;
  set: (wid: number, t: Target) => void;
}

export const useMarketTarget = create<MarketTargetState>((set, get) => ({
  byWorld: load(),
  set: (wid, t) => {
    const next = { ...get().byWorld, [String(wid)]: t };
    set({ byWorld: next });
    try {
      localStorage.setItem(KEY, JSON.stringify(next));
    } catch {
      /* private mode: remembered for this visit */
    }
  },
}));
